import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface I18nProviderProps {
  children: React.ReactNode;
}

const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkReady = () => {
      if (i18n.isInitialized) {
        setIsReady(true);
      } else {
        console.log("🌍 Waiting for i18n to initialize...");
        // Wait a bit and check again
        setTimeout(checkReady, 100);
      }
    };

    checkReady();
  }, [i18n]);

  if (!isReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading translations...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default I18nProvider;
